import { useEffect, useState } from "react";
import { ChevronUp } from "lucide-react";

export default function BackToTopFab() {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > 500);
    window.addEventListener("scroll", onScroll, { passive: true });
    onScroll();
    return () => window.removeEventListener("scroll", onScroll);
  }, []);
  if (!visible) return null;
  return (
    <button
      type="button"
      onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
      className="fixed right-4 bottom-20 lg:bottom-8 z-40 w-12 h-12 rounded-full bg-gradient-to-br from-[#DC2626] via-[#EA580C] to-[#F59E0B] text-white shadow-xl ring-2 ring-white hover:scale-110 transition flex items-center justify-center"
      aria-label="Back to top"
      data-testid="back-to-top-fab"
    >
      <ChevronUp className="w-6 h-6" strokeWidth={3}/>
    </button>
  );
}
